/**
 * This file is auto-generated by build-enums.ts. Do not edit directly.
 * Instead run `pnpm build-enums`
 *
 * This file contains all the enums defined in the GraphQL schema.
 * It also contains a type for each enum that is a string literal of the enum name.
 * This is useful for type safety when using the enum in the frontend.
 */
export enum ExternalGitProvider {
  Github = 'Github',
  GithubEnterprise = 'GithubEnterprise',
  AzureDevOps = 'AzureDevOps',
  BitBucket = 'BitBucket',
  GitLab = 'GitLab',
  GitLabEnterprise = 'GitLabEnterprise',
  Other = 'Other',
  ProphecyManaged = 'ProphecyManaged',
  Unknown = 'Unknown'
}

export type ExternalGitProviderType = `${ExternalGitProvider}`;

export enum InvitationStatus {
  accepted = 'accepted',
  rejected = 'rejected',
  requested = 'requested',
  requestedWithSeat = 'requestedWithSeat',
  suspended = 'suspended',
  received = 'received'
}

export type InvitationStatusType = `${InvitationStatus}`;

export enum VersionControlMode {
  Simple = 'Simple',
  Advanced = 'Advanced'
}

export type VersionControlModeType = `${VersionControlMode}`;

export enum Version {
  Draft = 'Draft',
  Published = 'Published'
}

export type VersionType = `${Version}`;

export enum BackEndCodeLanguage {
  scala = 'scala',
  python = 'python',
  sql = 'sql'
}

export type BackEndCodeLanguageType = `${BackEndCodeLanguage}`;

export enum GitProvider {
  ProphecyManaged = 'ProphecyManaged',
  External = 'External'
}

export type GitProviderType = `${GitProvider}`;

export enum ProfessionalEditionPlan {
  Starter = 'Starter',
  Pro = 'Pro',
  Enterprise = 'Enterprise'
}

export type ProfessionalEditionPlanType = `${ProfessionalEditionPlan}`;

export enum TeamState {
  enabled = 'enabled',
  disabled = 'disabled'
}

export type TeamStateType = `${TeamState}`;

export enum GitCombinedStorageModel {
  Simple = 'Simple',
  Normal = 'Normal',
  NormalWithForks = 'NormalWithForks'
}

export type GitCombinedStorageModelType = `${GitCombinedStorageModel}`;

export enum WorkflowMode {
  batch = 'batch',
  stream = 'stream'
}

export type WorkflowModeType = `${WorkflowMode}`;

export enum BuildSystem {
  maven = 'maven',
  wheel = 'wheel',
  sql = 'sql'
}

export type BuildSystemType = `${BuildSystem}`;

export enum DefaultTransformationEntity {
  Model = 'Model',
  Pipeline = 'Pipeline'
}

export type DefaultTransformationEntityType = `${DefaultTransformationEntity}`;

export enum MergeStatus {
  Success = 'Success',
  Conflicted = 'Conflicted'
}

export type MergeStatusType = `${MergeStatus}`;

/** Supported aspect types */
export enum AspectKind {
  /** List of Pipeline in job */
  PipelinesInJob = 'PipelinesInJob',
  /** Data quality expectations */
  DataQualityExpectation = 'DataQualityExpectation',
  /** Dependency information */
  Dependency = 'Dependency',
  /** Version information */
  Version = 'Version',
  /** Configuration content. Versioned. */
  Configuration = 'Configuration',
  /** Hive metastore related information. */
  Storage = 'Storage',
  /** Airflow connections info */
  AirflowConnectionInfo = 'AirflowConnectionInfo',
  /** Unit test execution result information */
  TestResult = 'TestResult',
  /** Dag Information  */
  DagInformation = 'DagInformation',
  /** Job size information like resources etc. */
  JobSize = 'JobSize',
  /** Spark Provider Information for a fabric */
  SparkProviderInfo = 'SparkProviderInfo',
  /** Airflow Provider Information for a fabric */
  AirflowProviderInfo = 'AirflowProviderInfo',
  /** Sql Provider Information for a fabric */
  SqlProviderInfo = 'SqlProviderInfo',
  /** Orchestration Provider Information for a fabric */
  OrchestrationProviderInfo = 'OrchestrationProviderInfo',
  /** DQ Provider Information for a fabric */
  DQProviderInfo = 'DQProviderInfo',
  /** SQL fabric creds info */
  SqlFabricCredsInfo = 'SqlFabricCredsInfo',
  /** Code content. Versioned. */
  Code = 'Code',
  /** Unit Tests. Versioned. */
  TestVisual = 'TestVisual',
  /** Dataset schema information */
  Schema = 'Schema',
  /** Version information of Entity */
  MigrationInfo = 'MigrationInfo',
  /** Commit ids sorted by date for deploy option in scheduler */
  ListCommits = 'ListCommits',
  /** Git storage information like repo url etc. */
  GitStorage = 'GitStorage',
  /** Git storage information like repo url etc. for Projects */
  GitConfig = 'GitConfig',
  /** General information like description */
  Info = 'Info',
  /** Code dependency information */
  CodeDeps = 'CodeDeps',
  /** Lineage Branch information */
  LineageBranch = 'LineageBranch',
  /** Lineage */
  Lineage = 'Lineage',
  /** Project's initial config include description and dependency details */
  ProjectInitialConfig = 'ProjectInitialConfig',
  /** Lineage Release information */
  LineageRelease = 'LineageRelease',
  /** Lineage Commit information */
  LineageCommit = 'LineageCommit',
  /** Cluster information */
  ClusterInfo = 'ClusterInfo',
  /** User fabric info for all fabrics */
  UserAllFabricInfo = 'UserAllFabricInfo',
  /** Onboarding info */
  OnboardingInfo = 'OnboardingInfo',
  /** Livy proxy user */
  LivyProxyUser = 'LivyProxyUser',
  /** Job Deployment Airflow Info */
  JobDeploymentAirflowInfo = 'JobDeploymentAirflowInfo',
  /** ExpressionInfo */
  ExpressionsInfo = 'ExpressionsInfo',
  /** Databricks Deployment */
  DatabricksDeployment = 'DatabricksDeployment',
  /** Run Info */
  RunInfo = 'RunInfo',
  /** Transpiler Import Input Info */
  InputInfo = 'InputInfo',
  /** Transpiler Import Output Pipeline Info */
  OutputInfo = 'OutputInfo',
  /** Detailed information for datasets in Pipeline Runs */
  DatasetDetails = 'DatasetDetails',
  /** Interim content for a dataset */
  Interim = 'Interim',
  /** Partner Info aspect */
  PartnerInfo = 'PartnerInfo',
  /** Resolution Mode for library */
  ResolutionModeInfo = 'ResolutionModeInfo',
  /** SQL Info */
  SQLInfo = 'SQLInfo',
  /** Admin level information for an entity */
  AdminInfo = 'AdminInfo',
  /** NonVersioned Code (branch) */
  NonVersionedCodeBranch = 'NonVersionedCodeBranch',
  /** NonVersioned Code (commit) */
  NonVersionedCodeCommit = 'NonVersionedCodeCommit',
  /** ProphecyManaged Fabric Service Principal Info */
  FabricServicePrincipalInfo = 'FabricServicePrincipalInfo',
  /** OIDC Info */
  OIDCInfo = 'OIDCInfo',
  /** Job files SHA aspect */
  JobFilesSHA = 'JobFilesSHA',
  /** Airflow Connections Info */
  AirflowConnections = 'AirflowConnections',
  /** Deployment State */
  DeploymentState = 'DeploymentState',
  /** Project Deployment Settings */
  DeploymentSettings = 'DeploymentSettings',
  /** Fabric Service principal state */
  FabricServicePrincipalState = 'FabricServicePrincipalState',
  /** Build cache */
  BuildCache = 'BuildCache',
  /** Enabled transpilers for that team */
  EnabledTranspilers = 'EnabledTranspilers',
  /** OAuth information for a user-host combination */
  UserOAuth = 'UserOAuth',
  /** Project Creation Default settings */
  ProjectCreationDefaults = 'ProjectCreationDefaults'
}

export type AspectKindType = `${AspectKind}`;

/** SelectionType */
export enum Section {
  /** EntityAndAspects */
  EntityAndAspects = 'EntityAndAspects',
  /** Author */
  Author = 'Author',
  /** Team */
  Team = 'Team',
  /** Project */
  Project = 'Project',
  /** Recency */
  Recency = 'Recency'
}

export type SectionType = `${Section}`;

/** ItemSelectionType */
export enum ItemSelection {
  AtMostOne = 'AtMostOne',
  ExactlyOne = 'ExactlyOne',
  Many = 'Many'
}

export type ItemSelectionType = `${ItemSelection}`;

/** Type of search term for in-memory search */
export enum Search {
  /** Match by entity name */
  Name = 'Name',
  /** Match by column name */
  Column = 'Column'
}

export type SearchType = `${Search}`;

/** Supported entity types */
export enum EntityKind {
  /** Deployment Entity */
  Deployment = 'Deployment',
  /** Entity Deployment */
  EntityDeployment = 'EntityDeployment',
  /** Repository Entity */
  Repository = 'Repository',
  /** Team Entity */
  Team = 'Team',
  /** Dataset Entity */
  Dataset = 'Dataset',
  /** Stored Procedure */
  StoredProcedure = 'StoredProcedure',
  /** Schedule Entity - renamed to Job */
  Schedule = 'Schedule',
  /** Job Entity */
  Job = 'Job',
  /** PhysicalDataset Entity */
  PhysicalDataset = 'PhysicalDataset',
  /** Workflow Entity - renamed to Pipeline */
  Workflow = 'Workflow',
  /** Pipeline Entity */
  Pipeline = 'Pipeline',
  /** Project Entity */
  Project = 'Project',
  /** Subgraph Entity */
  Subgraph = 'Subgraph',
  /** SQLModel Entity */
  SQLModel = 'SQLModel',
  /** SQLMacro Entity */
  SQLMacro = 'SQLMacro',
  /** SQLSeed Entity */
  SQLSeed = 'SQLSeed',
  /** SQLSource Entity */
  SQLSource = 'SQLSource',
  /** SQLTable Entity */
  SQLTable = 'SQLTable',
  /** SQLUnreferencedSource Entity */
  SQLUnreferencedSource = 'SQLUnreferencedSource',
  /** SQLPipeline Entity */
  SQLPipeline = 'SQLPipeline',
  /** SQLSnapshot Entity */
  SQLSnapshot = 'SQLSnapshot',
  /** SQLTest Entity */
  SQLTest = 'SQLTest',
  /** SQL Orchestrator Pipeline */
  SQLOrchestratorPipeline = 'SQLOrchestratorPipeline',
  /** SQL BusinessApp */
  SQLBusinessApp = 'SQLBusinessApp',
  /** SQL Stored Procedure */
  SQLStoredProcedure = 'SQLStoredProcedure',
  /** Configuration Entity */
  Configuration = 'Configuration',
  /** PipelineConfigurations Entity */
  PipelineConfigurations = 'PipelineConfigurations',
  /** User Entity */
  User = 'User',
  /** Fabric Entity */
  Fabric = 'Fabric',
  /** Functions Entity */
  Functions = 'Functions',
  /** Gem Entity */
  Gem = 'Gem',
  /** Udf Entity */
  UDF = 'UDF',
  /** Udaf Entity */
  UDAF = 'UDAF',
  /** BusinessRule Entity */
  BusinessRule = 'BusinessRule',
  /** Expression Entity */
  Expression = 'Expression',
  /** Airflow Function Entity */
  AirflowFunction = 'AirflowFunction',
  /** Dependency Entity */
  Dependency = 'Dependency',
  /** ProjectRelease Entity */
  ProjectRelease = 'ProjectRelease',
  /** JobRelease Entity */
  JobRelease = 'JobRelease',
  /** TranspilerImport Entity */
  TranspilerImport = 'TranspilerImport',
  /** Template Entity */
  Template = 'Template',
  /** BulkTranspilerImport Entity */
  BulkTranspilerImport = 'BulkTranspilerImport',
  /** Fabric Connector */
  Connector = 'Connector',
  /** Connector Run History */
  ConnectorRunHistory = 'ConnectorRunHistory',
  /** Interactive Spark Session */
  InteractiveSparkSession = 'InteractiveSparkSession',
  /** Secrets */
  Secrets = 'Secrets',
  /** Orchestration Connection Entity */
  OrchestrationConnection = 'OrchestrationConnection',
  /** Orchestration Secret Entity */
  OrchestrationSecret = 'OrchestrationSecret',
  /** Orchestrator Deployment */
  OrchestratorDeployment = 'OrchestratorDeployment'
}

export type EntityKindType = `${EntityKind}`;

/** Supported Commit Log Mutation Type */
export enum CommitLogEntityMutation {
  /** New Mutation */
  New = 'New',
  /** Modified Mutation */
  Modified = 'Modified',
  /** Deleted Mutation */
  Deleted = 'Deleted',
  /** Unmodified Mutation */
  Unmodified = 'Unmodified'
}

export type CommitLogEntityMutationType = `${CommitLogEntityMutation}`;

/** Forking Modes for Git Repo */
export enum ForkMode {
  Multi = 'Multi',
  Single = 'Single'
}

export type ForkModeType = `${ForkMode}`;

/** Type of fork of the repository [Master / User] */
export enum Fork {
  Master = 'Master',
  User = 'User'
}

export type ForkType = `${Fork}`;

/** User role in team */
export enum Role {
  owner = 'owner',
  admin = 'admin',
  member = 'member'
}

export type RoleType = `${Role}`;

/** Status for a entity in Deployment */
export enum DeploymentEntityStatus {
  Added = 'Added',
  Refreshed = 'Refreshed',
  Deleted = 'Deleted'
}

export type DeploymentEntityStatusType = `${DeploymentEntityStatus}`;

/** Deployment Status for a deployment */
export enum DeploymentStatus {
  NotStated = 'NotStated',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed'
}

export type DeploymentStatusType = `${DeploymentStatus}`;

/** secrets provider types */
export enum SecretsProvider {
  Databricks = 'Databricks',
  HashiCorp = 'HashiCorp',
  Environment = 'Environment'
}

export type SecretsProviderType = `${SecretsProvider}`;

/** Supported resolution types */
export enum ResolutionStrategy {
  LeftBranch = 'LeftBranch',
  RightBranch = 'RightBranch'
}

export type ResolutionStrategyType = `${ResolutionStrategy}`;

export enum Industry {
  Finance = 'Finance',
  Healthcare = 'Healthcare',
  Manufacturing = 'Manufacturing',
  Energy = 'Energy',
  Transportation = 'Transportation',
  Retail = 'Retail',
  Hospitality = 'Hospitality',
  Other = 'Other'
}

export type IndustryType = `${Industry}`;

export enum Project {
  PublicAccess = 'PublicAccess',
  UserManaged = 'UserManaged'
}

export type ProjectType = `${Project}`;

export enum Remote {
  Local = 'Local',
  Upstream = 'Upstream',
  Origin = 'Origin'
}

export type RemoteType = `${Remote}`;

export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type SortOrderType = `${SortOrder}`;

export enum SortColumn {
  Created = 'Created',
  Modified = 'Modified'
}

export type SortColumnType = `${SortColumn}`;

export enum GitTagState {
  ExternalAndInternallyReleased = 'ExternalAndInternallyReleased',
  InternalReleased = 'InternalReleased',
  ExternalUnReleased = 'ExternalUnReleased'
}

export type GitTagStateType = `${GitTagState}`;

/** Project's Git Repos Syncing Modes */
export enum SyncMode {
  External = 'External',
  Internal = 'Internal'
}

export type SyncModeType = `${SyncMode}`;

/** Type of User's Account */
export enum UserAccount {
  /** Licensed Account for SaSS User */
  CeLicenseAcquired = 'CeLicenseAcquired',
  /** The Default Account for User */
  Enterprise = 'Enterprise',
  /** A user coming from AWS */
  AwsMarketplace = 'AwsMarketplace',
  /** A user coming from Azure */
  AzureMarketplace = 'AzureMarketplace',
  /** Free Account for SaSS User */
  CeFree = 'CeFree',
  /** A user coming from Databricks Partner Hub */
  DatabricksPartner = 'DatabricksPartner',
  /** A user which is on Enterprise Trial */
  EnterpriseTrial = 'EnterpriseTrial',
  /** A user to manage Prophecy cluster */
  ClusterAdmin = 'ClusterAdmin',
  /** A support user to manage Prophecy IDE */
  Support = 'Support'
}

export type UserAccountType = `${UserAccount}`;

/** The user managed type */
export enum UserManaged {
  /** The prophecy managed user type */
  ProphecyManaged = 'ProphecyManaged',
  /** The LDAP managed user type */
  Ldap = 'Ldap',
  /** The SAML managed user type */
  Saml = 'Saml',
  /** The AzureAD managed user type */
  AzureAd = 'AzureAd',
  /** The Google managed user type */
  Google = 'Google'
}

export type UserManagedType = `${UserManaged}`;

/** The user managed type */
export enum UserAttribute {
  /** default attribute */
  DefaultAttr = 'DefaultAttr',
  /** attribute through which user can deploy */
  DeploymentAttr = 'DeploymentAttr'
}

export type UserAttributeType = `${UserAttribute}`;

/** Scheduler Enum */
export enum Scheduler {
  /** Amazon Managed Workflows for Apache Airflow */
  MWAA = 'MWAA',
  /** Astronomer - Airflow */
  Astronomer = 'Astronomer',
  /** Databricks Jobs */
  Databricks = 'Databricks',
  /** Composer */
  Composer = 'Composer',
  /** Open source */
  Prophecy = 'Prophecy',
  /** Open source */
  OpenSource = 'OpenSource'
}

export type SchedulerType = `${Scheduler}`;

/** Cloud Provider Enum */
export enum CloudProvider {
  /** Amazon Web Services */
  AWS = 'AWS',
  /** Microsoft Azure */
  Azure = 'Azure',
  /** Google Cloud Provider */
  GCP = 'GCP'
}

export type CloudProviderType = `${CloudProvider}`;

/** Release Status enum */
export enum Status {
  /** Pending, Not Started */
  Pending = 'Pending',
  /** RUNNING */
  Running = 'Running',
  /** Succeeded */
  Succeeded = 'Succeeded',
  /** Retrying */
  Retrying = 'Retrying',
  /** Failed */
  Failed = 'Failed'
}

export type StatusType = `${Status}`;

export enum TeamKind {
  ProphecyManaged = 'ProphecyManaged',
  ProphecyManagedPersonal = 'ProphecyManagedPersonal',
  IdpOrganizationWide = 'IdpOrganizationWide',
  IdpGroup = 'IdpGroup'
}

export type TeamKindType = `${TeamKind}`;

export enum ConnectionRunStatus {
  Running = 'Running',
  CompletedSuccessfully = 'CompletedSuccessfully'
}

export type ConnectionRunStatusType = `${ConnectionRunStatus}`;

export enum AWSAccessProvider {
  USER_PROVIDED_CREDENTIALS = 'USER_PROVIDED_CREDENTIALS',
  FABRIC_PROVIDED_CREDENTIALS = 'FABRIC_PROVIDED_CREDENTIALS',
  ENVIRONMENT_PROVIDED_CREDENTIALS = 'ENVIRONMENT_PROVIDED_CREDENTIALS',
  ARN_PROVIDED_CREDENTIALS = 'ARN_PROVIDED_CREDENTIALS'
}

export type AWSAccessProviderType = `${AWSAccessProvider}`;

export enum Connector {
  DatabricksConnectorType = 'DatabricksConnectorType',
  GlueConnectorType = 'GlueConnectorType'
}

export type ConnectorType = `${Connector}`;

export enum ShareScope {
  Public = 'Public',
  Private = 'Private',
  NoAccess = 'NoAccess'
}

export type ShareScopeType = `${ShareScope}`;

export enum Link {
  Snapshot = 'Snapshot',
  Live = 'Live'
}

export type LinkType = `${Link}`;

/** Type of file system entry */
export enum FileEntry {
  File = 'File',
  Directory = 'Directory'
}

export type FileEntryType = `${FileEntry}`;
